import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "bg-about-background bg-top pb-20 bg-[length:130rem] h-full bg-no-repeat bg-white pt-28" }
const _hoisted_2 = { class: "mx-auto max-w-4xl pb-56" }
const _hoisted_3 = { class: "mb-6 flex flex-col gap-2" }
const _hoisted_4 = { class: "flex items-center gap-2 text-sm font-medium text-gray-500" }
const _hoisted_5 = {
  key: 0,
  class: "mt-6 grid gap-4"
}
const _hoisted_6 = { class: "flex flex-col gap-4 md:flex-row md:items-start md:justify-between" }
const _hoisted_7 = { class: "text-gray-900 text-lg font-semibold" }
const _hoisted_8 = { class: "mt-2 flex flex-wrap items-center gap-2 text-xs text-gray-600" }
const _hoisted_9 = { class: "inline-flex items-center gap-1 rounded-full bg-gray-100 px-2 py-1" }
const _hoisted_10 = { class: "inline-flex items-center gap-1 rounded-full bg-gray-100 px-2 py-1" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "mt-4 mb-2 flex justify-between items-center" }
const _hoisted_13 = { class: "text-sm text-gray-700" }
const _hoisted_14 = ["aria-valuenow"]
const _hoisted_15 = {
  key: 1,
  class: "mt-6 text-sm text-gray-500"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AcademicCapIcon = _resolveComponent("AcademicCapIcon")!
  const _component_Squares2X2Icon = _resolveComponent("Squares2X2Icon")!
  const _component_PlayCircleIcon = _resolveComponent("PlayCircleIcon")!
  const _component_ArrowRightIcon = _resolveComponent("ArrowRightIcon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_AcademicCapIcon, { class: "h-4 w-4 text-primary" }),
          _cache[0] || (_cache[0] = _createTextVNode(" Academy "))
        ]),
        _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "text-gray-900 text-3xl font-semibold" }, " Your Learning ", -1)),
        _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-gray-600" }, " Track your progress and continue your courses. ", -1))
      ]),
      (_ctx.courses.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courses, (course) => {
              return (_openBlock(), _createElementBlock("div", {
                key: course._id,
                class: "bg-white p-6 border border-gray-200 shadow-sm rounded-2xl"
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", null, [
                    _createElementVNode("h2", _hoisted_7, _toDisplayString(course.title), 1),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("span", _hoisted_9, [
                        _createVNode(_component_Squares2X2Icon, { class: "h-3.5 w-3.5" }),
                        _createTextVNode(" " + _toDisplayString(course.modules.length) + " Modules ", 1)
                      ]),
                      _createElementVNode("span", _hoisted_10, [
                        _createVNode(_component_PlayCircleIcon, { class: "h-3.5 w-3.5" }),
                        _createTextVNode(" " + _toDisplayString(_ctx.getTotalVideos(course)) + " Videos ", 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    (!_ctx.isEnrolled(course._id))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "inline-flex items-center rounded-full bg-primary px-4 py-2 text-sm font-semibold text-gray-900 hover:bg-[#c9ad99]",
                          onClick: ($event: any) => (_ctx.enrollCourse(course._id))
                        }, [
                          _cache[3] || (_cache[3] = _createTextVNode(" Start ")),
                          _createVNode(_component_ArrowRightIcon, { class: "ml-2 h-4 w-4" })
                        ], 8, _hoisted_11))
                      : (_openBlock(), _createBlock(_component_router_link, {
                          key: 1,
                          to: `/dashboard/course/${course._id}`,
                          class: "inline-flex items-center rounded-full bg-primary px-4 py-2 text-sm font-semibold text-gray-900 hover:bg-[#c9ad99]"
                        }, {
                          default: _withCtx(() => [
                            _cache[4] || (_cache[4] = _createTextVNode(" Continue Course ")),
                            _createVNode(_component_ArrowRightIcon, { class: "ml-2 h-4 w-4" })
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _cache[5] || (_cache[5] = _createElementVNode("h3", { class: "text-sm font-medium text-gray-700" }, " Progress ", -1)),
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.computeCourseProgress(course)) + "% Complete ", 1)
                ]),
                _createElementVNode("div", {
                  "aria-valuenow": _ctx.computeCourseProgress(course),
                  "aria-valuemax": "100",
                  "aria-valuemin": "0",
                  class: "flex w-full h-1 rounded-full overflow-hidden bg-gray-200",
                  role: "progressbar"
                }, [
                  _createElementVNode("div", {
                    style: _normalizeStyle({ width: _ctx.computeCourseProgress(course) + '%' }),
                    class: "flex flex-col justify-center overflow-hidden bg-primary text-xs text-white text-center whitespace-nowrap transition duration-500"
                  }, null, 4)
                ], 8, _hoisted_14)
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_15, " No courses available. "))
    ])
  ]))
}